import { FC } from 'react';
import { StampDutyWrapper } from './StampDutyWrapper/StampDutyWrapper';

export type Props = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    nodeData: Record<string, any>;
};
export const ReactComponentEntry: FC<React.PropsWithChildren<Props>> = ({
    nodeData
}) => {
    switch (nodeData?.fields?.componentName) {
        case 'Stamp Duty Calculator':
            return (
                <StampDutyWrapper
                    title={nodeData?.fields?.title}
                    body={nodeData?.fields?.body}
                />
            );

        // add more wrappers here!

        default:
            return <>Component not updated yet</>;
    }
};
